//财务管理
let finance = [
    {
        path: '/finance/recharge',
        name: 'recharge',
        component: () => import('@/views/finance/recharge.vue'),
        meta: {keepAlive: true, parentPath: 'finance'},
    },
    {
        path: '/finance/bill',
        name: 'bill',
        component: () => import('@/views/finance/bill.vue'),
        meta: {keepAlive: true, parentPath: 'finance'},
    }
    ,
    {
        path: '/finance/bookorder',
        name: 'bookorder',
        component: () => import('@/views/finance/bookorder.vue'),
        meta: {keepAlive: true, parentPath: 'finance'},
    }
    ,
    {
        path: '/finance/memberrecord',
        name: 'memberrecord',
        component: () => import('@/views/finance/memberrecord.vue'),
        meta: {keepAlive: true, parentPath: 'finance'},
    }
    ,
    {
        path: '/finance/withdraw',
        name: 'withdraw',
        component: () => import('@/views/finance/withdraw.vue'),
        meta: {keepAlive: true, parentPath: 'finance'},
    }
    
]
export default finance


// WEBPACK FOOTER //
// ./src/router/finance.js